import type { ComposerTranslation } from 'vue-i18n'
import type { ValidationSchema } from '../composables/useFormValidation'
import {
  createRequiredFieldValidator,
  createEmailFieldValidator,
  createNameFieldValidator,
  createPasswordFormatValidator,
} from './StringValidator'

export function passwordChangeSchema(
  t: ComposerTranslation,
  currentPassword: string,
  newPassword: string,
  confirmPassword: string,
): ValidationSchema {
  return {
    currentPassword: {
      value: currentPassword,
      validators: [createRequiredFieldValidator(t, 'currentPassword')],
    },
    newPassword: {
      value: newPassword,
      validators: [
        createRequiredFieldValidator(t, 'newPassword'),
        createPasswordFormatValidator(t, 'newPassword'),
      ],
    },
    confirmPassword: {
      value: confirmPassword,
      validators: [createRequiredFieldValidator(t, 'confirmPassword')],
    },
  }
}

export function addressSchema(
  t: ComposerTranslation,
  fields: {
    firstName: string
    address1: string
    city: string
    postalCode: string
    country: string
    state?: string
  },
): ValidationSchema {
  const schema: ValidationSchema = {
    firstName: {
      value: fields.firstName,
      validators: [createRequiredFieldValidator(t, 'firstName')],
    },
    address1: {
      value: fields.address1,
      validators: [createRequiredFieldValidator(t, 'addressLine1')],
    },
    city: {
      value: fields.city,
      validators: [createRequiredFieldValidator(t, 'city')],
    },
    postalCode: {
      value: fields.postalCode,
      validators: [createRequiredFieldValidator(t, 'postalCode')],
    },
    country: {
      value: fields.country,
      validators: [createRequiredFieldValidator(t, 'country')],
    },
  }

  if (fields.country === 'US' || fields.country === 'CA') {
    schema.state = {
      value: fields.state ?? '',
      validators: [createRequiredFieldValidator(t, 'stateCode')],
    }
  }

  return schema
}

export function profileSchema(
  t: ComposerTranslation,
  fields: {
    firstName: string
    lastName: string
    emailAddress: string
  },
): ValidationSchema {
  return {
    firstName: {
      value: fields.firstName,
      validators: [
        createRequiredFieldValidator(t, 'firstName'),
        createNameFieldValidator(t, 'firstName'),
      ],
    },
    lastName: {
      value: fields.lastName,
      validators: [
        createRequiredFieldValidator(t, 'lastName'),
        createNameFieldValidator(t, 'lastName'),
      ],
    },
    emailAddress: {
      value: fields.emailAddress,
      validators: [
        createRequiredFieldValidator(t, 'emailAddress'),
        createEmailFieldValidator(t, 'emailAddress'),
      ],
    },
  }
}
